// DISPLAY-ONLY mirror of the backend's season boundaries. Never used for
// filtering/aggregation logic — the backend (O3-Backend/app/domain/seasons.js)
// remains authoritative for all classification and query filtering. This file
// only supplies labels for filter dropdowns and display badges.
//
// Source of truth: O3-Backend/app/domain/seasons.js (SEASONS array). If a season
// boundary ever changes there, update the `id`/`label` pairs here to match.
export const SEASONS = [
    { id: 'S8', label: 'Season 8' },
    { id: 'S9', label: 'Season 9' },
    { id: 'S10', label: 'Season 10' },
    // 2025-07-01 .. 2025-12-31 is intentionally undefined on the backend — no
    // entry here either.
    { id: 'S11', label: 'Season 11' },
    { id: 'S12', label: 'Season 12' },
];

export function seasonLabel(id) {
    const season = SEASONS.find((s) => s.id === id);
    return season ? season.label : id || 'Unclassified';
}

export function listSeasonOptions() {
    return SEASONS.map((s) => ({ value: s.id, label: s.label }));
}
